import { CheckCircle, type IconProps } from '@onefish/icons-react';
import { Icon } from '../Icon';

export const NotificationSuccessIcon = (props: IconProps) => {
  return <Icon as={CheckCircle} weight="fill" color="var(--primary-color)" {...props} />;
};
